'use client';

import { useDispatch, useSelector } from 'react-redux';
import { toggleSimplifyMode } from '../../../../../apps/frontend/src/redux/slices/globalSlice';

export const SimplifyModeToggle = () => {
  const dispatch = useDispatch();
  const simplifyMode = useSelector((state) => state.global.simplifyMode);

  return (
    <div
      className="fixed bottom-20 md:bottom-4 left-1/2 transform -translate-x-1/2 md:-translate-x-[34%] z-50 rounded-[12px] p-[2px] w-fit"
      style={{
        background: 'linear-gradient(to right, var(--q3-orange-normal), var(--q3-stroke-light))',
      }}
    >
      <div
        onClick={() => dispatch(toggleSimplifyMode())}
        className="flex items-center gap-3 px-4 py-2 bg-[var(--q3-surface-default)] rounded-[12px] backdrop-blur-sm cursor-pointer transition-all duration-300"
      >
        <span className="text-sm font-medium text-[var(--q3-neutral-default)] whitespace-nowrap">
          Simplify Mode is {simplifyMode ? 'On' : 'Off'}
        </span>
        <div
          className={`w-12 h-6 rounded-full relative transition-colors duration-300 ${
            simplifyMode ? 'bg-red-400' : 'bg-[var(--q3-neutral-light)]'
          }`}
        >
          <div
            className={`w-5 h-5 bg-white rounded-full absolute top-0.5 left-0.5 shadow-md transition-transform duration-300 transform ${
              simplifyMode ? 'translate-x-6' : 'translate-x-0'
            }`}
          />
        </div>
      </div>
    </div>
  );
};
